import { useParams } from "react-router-dom";
import CustomForm from '../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../config/config';
import Fetch from '../../../core/util/core/Fetch';
import { useEffect, useState } from 'react';
import { chooseProfileFilter } from "../../helpers/chooseProfileFilter";
import sleep from "sleep-promise";

function Form() {
    const profileFilter = chooseProfileFilter()

    const hiddenValues = {}

    if (profileFilter.gci_company_id) {
        hiddenValues.gci_company_id = profileFilter.gci_company_id
    }

    const { id } = useParams();
    const [form, setForm] = useState();
    const [formContent, setFormContent] = useState(<>Carregando...</>);

    const endpointBackend = config.endpoints.backend;

    const paths = {
        endpointSave: `${endpointBackend}gci/accounting-plans/save`,
        endpointGetById: `${endpointBackend}gci/accounting-plans/getById`,
        endpointGetAllCompanies: `${endpointBackend}gci/companies/getall`,
        endpointGetAllAccountingPlans: `${endpointBackend}gci/accounting-plans/getall`,
        urlGoBack: `/gci/accounting-plans/list`,
        pathView: `/gci/accounting-plans/view`
    }

    const labels = {
        labelTitleAdd: "Novo Plano de Contas",
        labelTitleEdit: "Editar Plano de Contas",
        labelTitleView: 'Visualizar Plano de Contas'
    }

    const getForm = (values) => {

        let form = {
            hiddenValues,
            fields: [
                !profileFilter.gci_company_id ? {
                    name: 'gci_company_id',
                    type: 'select',
                    label: 'Empresa',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCompanies,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    handleChange: async (element, field, values) => {
                        values.gci_accounting_plan_id = null;
                        let form = getForm(values);
                        form.fields[1].autoFocus = true;
                        setForm(form);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />)
                    },
                    columnSize: 12
                } : {},
                {
                    name: 'gci_accounting_plan_id',
                    type: 'select',
                    label: 'Plano de Contas',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllAccountingPlans,
                        label: 'full_path',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                gci_company_id: profileFilter.gci_company_id || values.gci_company_id || null,
                            }
                        }
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
                {
                    name: 'name',
                    type: 'text',
                    label: 'Nome',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels,
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })

                if (values.ventures) {
                    const ventures = [];
                    values.ventures.map(venture => {
                        ventures.push(venture.gci_venture_id.value)
                    })

                    values.venturesIds = ventures
                }
            }

            console.log(values)

            const form = getForm(values);

            setForm(form);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />} />
            );
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
